<template>
  <div>
    <FormulaireClient mode="create" />
  </div>
</template>

<script>
  import FormulaireClient from "./FormulaireClient";

  export default {
    components: {
      FormulaireClient,
    },
  };
</script>
